import { Container, Sprite, Texture } from 'pixi.js';
import type { BoardModel } from '../../models/board/BoardModel';
import { gridPositionToPxPosition } from '../../utils/gridPositionToPxPosition';

export class BoardBackgroundLayer extends Container {
  private readonly tiles = new Map<string, Sprite>();

  private getTileId(x: number, y: number): string {
    return `${x},${y}`;
  }

  public fillTiles(model: BoardModel): void {
    this.removeAllTiles();
    model.getStacks().forEach((stack) => {
      this.addTile(stack.x, stack.y);
    });
  }

  public addTile(x: number, y: number): Sprite | null {
    const tileId = this.getTileId(x, y);
    if (this.tiles.has(tileId)) return null;
    const sprite = new Sprite(Texture.from('tile_empty')).props({
      position: gridPositionToPxPosition(x, y),
      parent: this,
      anchor: 0.5,
    });
    this.tiles.set(`${x},${y}`, sprite);
    return sprite;
  }

  public getTile(x: number, y: number): Sprite | null {
    return this.tiles.get(this.getTileId(x, y)) ?? null;
  }

  public removeTile(x: number, y: number): void {
    const tileId = this.getTileId(x, y);
    const tile = this.tiles.get(tileId);
    if (!tile) return;
    tile.destroy({ children: true });
    this.tiles.delete(tileId);
  }

  public removeAllTiles(): void {
    Array.from(this.tiles.values()).forEach((tile) => {
      tile.destroy({ children: true });
    });
    this.tiles.clear();
  }
}
